import { RESET_TABLE_FILTER, UPDATE_TABLE_FILTER, UPDATE_SELECTED_COLUMNS } from '../actionTypes';

export const table = (
	state = { filter: {}, sort: {}, selectedColumns: {} },
	action,
) => {
	switch (action.type) {
		case UPDATE_TABLE_FILTER:
			return {
				...state,
				...action.payload,
			};
		case UPDATE_SELECTED_COLUMNS:
			return {
				...state,
				selectedColumns: {
					...state.selectedColumns,
					[action.payload.listId]: action.payload.columnTitles,
				},
			};
		case RESET_TABLE_FILTER:
			return (state = { filter: {} });
		default:
			return state;
	}
};
